import htmx from "htmx.org"

declare global {
  interface Window {
    handleEnumClick: (
      event: InputEvent,
      isChecked: boolean,
      formId: string,
    ) => void
  }
}

window.handleEnumClick = (event, isChecked, formId) => {
  const self = event.target as HTMLInputElement
  if (isChecked) {
    self.checked = false
  } else {
    self.checked = true
  }
  htmx.trigger(formId, "submit")
}
